import { Injectable } from '@angular/core';
import { UtilitiesModule } from '../utilities.module';

@Injectable({
  providedIn: UtilitiesModule
})
export class TickService {

  constructor() { }

  then(fn: () => any) {
    setTimeout(fn, 0);
  }
}
